//   'http://leadbank-api-1.disc.internal.oyorooms.ms/discovery/api/v1/oam';
import { encodeBase64 } from './utils';

const { getAppEnv } = require('../config/env');
const env = getAppEnv();

function getNonceIDList() {
  const ids = [];
  for (let itr = 0; itr < 1; itr++) {
    ids.push(Math.random().toString(36).substring(2,12));
  }
  return ids;
}

var SERVER_HOST = env.raw.BACKEND_LINK;
// var SERVER_HOST = "http://localhost:8080/discovery/api/v1/oam"
var OTP_BASE_URL = env.raw.OTP_BASE_URL;
export var BFF_HOST_URL=env.raw.BFF_API_URL;

var DEFAULT_TOKEN = env.raw.DEFAULT_TOKEN;

export var SERVER_HOST;
export var OTP_BASE_URL;

export var DEFAULT_TOKEN;

export const IDENTITY_APP_KEY = process.env.IDENTITY_APP_KEY;
export const IDENTITY_APP_SECRET = process.env.IDENTITY_APP_SECRET;

export const IDENTITY_ACCESS_TOKEN = encodeBase64(`${IDENTITY_APP_KEY}:${IDENTITY_APP_SECRET}`);

export const SEARCH_HOST =
  'http://autocomplete.oyorooms.io/autocomplete/search';

export const POMS_HOST = process.env.POMS_HOST;
export const POMS_ACCESS_TOKEN = process.env.POMS_ACCESS_TOKEN;

export const HMS_GLOBAL_INFO = process.env.HMS_GLOBAL_INFO ;
export const SELF_RELEASE_FLAG = process.env.SELF_RELEASE_FLAG ;
export const NONCE_LIST = getNonceIDList();
